import React from 'react';

// COMPONENTS
import OrderCardInfo from './OrderCardInfo';

// DS
import { Col, Row } from '@vertem-core/vertice-ds';

// ENUMS
import { EVendorType } from 'enums/orders';

// TYPES
import { OrdersArrayPropTypes } from './propTypes';

// STYLES
import 'Assets/styles/default/components/Orders/OrdersList/OrdersListStyles.less';

// UTILS
import generateUUID from 'Utils/generateUUID';
import CartEmpty from '../../Cart/CartEmpty/CartEmpty';
import OrderCardGift from './OrderCardGift';

// ORDERS LIST COMPONENT
const OrdersList = ({ ordersListData, isGift = false }) => {
  /* Renders */
  if (!ordersListData.length)
    return (
      <Col className="orders-component-wrapper col">
        <Row align={'center'} justify={'center'}>
          <div className={'padding-y-small'}>
            <CartEmpty
              icon={
                'https://vertice-ds.s3.amazonaws.com/Assets/Images/icons/empty_cart.svg'
              }
              title={`Você ainda não fez nenhum resgate!`}
              description={'Aproveite nossas ofertas!'}
              isGift={isGift}
            />
          </div>
        </Row>
      </Col>
    );
  return isGift ? (
    <Col className="orders-component-wrapper col">
      {ordersListData.map(
        ({
          description,
          imageUrl,
          name,
          iventory,
          quantity,
          status,
          shippingDays,
          createdAt,
          shippingDate,
          _id,
        }) => {
          return (
            <OrderCardGift
              key={generateUUID()}
              id={_id}
              createdAt={createdAt}
              description={description}
              imageUrl={imageUrl}
              name={name}
              iventory={iventory}
              quantity={quantity}
              status={status}
              shppingDays={shippingDays}
              shippingDate={shippingDate}
            />
          );
        }
      )}
    </Col>
  ) :  (
    <Col className="orders-component-wrapper col">
      {ordersListData.map((order) => {
        const isPaymentWithPointsAndCash =
          order.vendorOrderModel[0].vendorType === EVendorType.E_COMMERCE &&
          order.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal !== 0;
        const totalPointsValue = isPaymentWithPointsAndCash ? order.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal  : order.orderTotalValue;
        const totalCashValue = isPaymentWithPointsAndCash
          ? order.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal
          : 0;

        return (
          <OrderCardInfo
            key={generateUUID()}
            orderDate={order.createDate}
            orderId={order.parentOrderId}
            status={order.orderStatus}
            orderItems={order.vendorOrderModel}
            isPointAndCash={isPaymentWithPointsAndCash}
            totalPointsValue={totalPointsValue}
            totalCashValue={totalCashValue}
          />
        );
      })}
    </Col>
  );
};

OrdersList.propTypes = { ...OrdersArrayPropTypes };


export default OrdersList;
